import MedicineForm from './MedicineForm';
import { getAuthToken } from '../../../util/auth';
import { redirect } from 'react-router-dom';
import { getApiChara } from '../../../util/getApi';
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { FaPlusCircle } from 'react-icons/fa';
import { useTranslation } from "react-i18next";

const NewMedicine = () => {
    const { t } = useTranslation();
    return (
        <div style={{ maxWidth: '900px', margin: '0 auto' }}>
            <h3 className='textHead' style={{ color: 'var(--primary-color)', fontWeight: '700', textTransform: 'uppercase', letterSpacing: '1px' }}>
                <FaPlusCircle className="me-2" /> {t("Add Medicine")}
            </h3>
            <MedicineForm />
        </div>
    );
}

export default NewMedicine;

export async function action({ request, params }) {
    const data = await request.formData();
    const method = request.method;
    const MedicineData = {
        name: data.get('name'),
        medType: data.get('medType'),
        manufacturer: data.get('manufacturer'),
        price: data.get('price'),
        disease: data.get('disease'),
        expiryDate: data.get('expiryDate'),
        barcode: data.get('barcode'),
    }
    const token = getAuthToken();
    if (token === null || token === 'EXPIRED') {
        return redirect('/');
    }
    const apiChar = getApiChara();
    const apiUrl = `${apiChar}/medicine/addMedicine`;
    try {
        const response = await fetch(apiUrl, {
            method: method,
            body: JSON.stringify(MedicineData),
            headers: {
                'Content-Type': 'application/json',
                'authorization': 'Bearer ' + token
            }
        });

        let responseBody = await response.json(); // Read the response body once and store it in a variable

        const errorMsg = responseBody.errorMsg;
        if (errorMsg !== null) {
            responseBody.errorMsg = "Medicine Already Exists";
            toast.error("Medicine Already Exists");
            return responseBody;
        } else if (!response.ok) {
            toast.error("Could not save Medicine");
            throw new Error({ message: 'Could not save Medicine.', status: 500 });
        }

        toast.success("Medicine added successfully!");
        return redirect('..');
    } catch (error) {
        console.log(error) // Rethrow the error to handle it in the calling code
    }
}
